import { type ReactNode } from 'react';
import styles from '../TextInput.module.css';

export function Icon(props: {
  icon: ReactNode;
  ariaLabel?: string;
  action?: () => void;
}) {
  const { icon, action, ariaLabel } = props;
  return action ? (
    <button
      type="button"
      aria-label={ariaLabel}
      onClick={action}
      onMouseDown={(e) => e.preventDefault()}
      className={styles['icon-button']}
    >
      {icon}
    </button>
  ) : (
    <span aria-label={ariaLabel} className={styles['icon']}>
      {icon}
    </span>
  );
}
